import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./components/Sidebar";

function AdminLayout() {
  return (
    <div className="app">
      <Sidebar />
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}

export default AdminLayout;